import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';
import { HOME } from '../lib/site';
import MiniMentalCalculator from '../components/calculator/MiniMentalCalculator';
import { ToolBasis, ToolIndependenceNote } from '../components/CalculatorProtectionFrame';
import GuideNavigator from '../components/GuideNavigator';
import IntentLinks from '../components/IntentLinks';
import DoutoConduta from '../components/DoutoConduta';
import EditorialContent from '../components/EditorialContent';
import FAQ from '../components/FAQ';
import ReferencesAndAuthor from '../components/ReferencesAndAuthor';

const FACTS = [
  ['Sigla', 'MEEM / MMSE'],
  ['Finalidade', 'Rastreio cognitivo'],
  ['Pontuação máxima', '30 pontos'],
  ['Aplicação', 'Breve e estruturada'],
];

export default function Home() {
  const [resultVisible, setResultVisible] = useState(false);
  useSEO({ title: HOME.title, description: HOME.description, path: HOME.path });

  return (
    <div>
      <MiniMentalCalculator
        onResultVisibilityChange={setResultVisible}
        heading={
          <div className="min-w-0">
            <p className="text-[length:var(--fs-14)] font-medium text-[var(--accent)]">Versão brasileira · Brucki et al., 2003</p>
            <h1 className="mt-1 whitespace-nowrap !tracking-[-0.03em] !text-[length:min(1.375rem,calc((100vw-2rem)/16.4))] md:!text-[length:var(--fs-28)]">Calculadora do Mini Mental (MEEM)</h1>
            <p className="mt-1.5 max-w-[62ch] text-[length:var(--fs-15)] leading-snug text-[var(--ink-2)]">Marque cada item durante a aplicação. A soma, a leitura por escolaridade e o texto para o prontuário saem prontos.</p>
            <p className="mt-2 flex flex-wrap gap-x-3 gap-y-0.5 text-[length:var(--fs-13)] text-[var(--ink-2)]">
              <span>Gratuita</span><span aria-hidden="true">·</span><span>Cálculo no seu navegador</span><span aria-hidden="true">·</span><span>Revisão: Dr. Carlos Felipe, CRM-MG 105.721</span>
            </p>
            <p className="mt-2">
              <Link to="/pro#acesso" data-analytics-event="home_free_cta_clicked" className="inline-flex min-h-11 items-center gap-1.5 rounded-[8px] border border-[var(--accent)] px-3 text-[length:var(--fs-14)] font-semibold text-[var(--accent)] hover:bg-[var(--hover)]">
                Acompanhe a evolução de cada paciente: conta grátis →
              </Link>
            </p>
          </div>
        }
      />

      {/* Conteúdo de apoio e SEO: fica no HTML (details é indexável), só não disputa a primeira dobra. */}
      <div className="mx-auto mt-8 max-w-[820px] px-4">
        <details id="sobre-o-meem" className="border-y border-[var(--line)]">
          <summary className="flex min-h-12 cursor-pointer items-center text-[length:var(--fs-17)] font-semibold text-[var(--ink)]">Sobre o MEEM</summary>
          <div className="grid gap-6 pb-6 pt-2 md:grid-cols-[minmax(0,1fr)_280px]">
            <div>
              <p className="text-[length:var(--fs-17)] leading-relaxed text-[var(--ink)]">
                Esta página é a calculadora online do <strong>Mini Exame do Estado Mental (MEEM)</strong>, também conhecido como Mini Mental. Some os pontos por domínio e veja a leitura por escolaridade. Para entender o significado do escore, acesse <Link to="/interpretacao-dos-resultados" className="text-[var(--primary)] underline">como interpretar o resultado do Mini Mental</Link>.
              </p>

              <p className="margin-note mt-5 px-4 py-3 text-[length:var(--fs-15)] leading-relaxed">
                <strong>Aviso:</strong> o desempenho pode ser influenciado por escolaridade, condições sensoriais, linguagem, estado emocional, delirium, dor, fadiga e outras condições clínicas.
              </p>

              <p className="mt-5 text-[length:var(--fs-15)]">
                <Link to="/como-aplicar" className="inline-flex min-h-11 items-center text-[var(--ink)] underline">Vai aplicar agora? Veja como aplicar o Mini Mental →</Link>
              </p>
              <p className="text-[length:var(--fs-15)]">
                <Link to="/pro#acesso" data-analytics-event="home_free_cta_clicked" className="inline-flex min-h-11 items-center text-[var(--ink)] underline">Guardar o histórico dos pacientes: conta gratuita →</Link>
              </p>
            </div>

            <div>
              <dl className="border-t border-[var(--line)] text-[length:var(--fs-15)]">
                {FACTS.map(([label, value]) => (
                  <div key={label} className="flex justify-between gap-4 border-b border-[var(--line)] py-2.5">
                    <dt className="text-[var(--ink-2)]">{label}</dt>
                    <dd className="font-semibold text-[var(--ink)]">{value}</dd>
                  </div>
                ))}
              </dl>
              <div className="mt-5">
                <ToolIndependenceNote />
              </div>
            </div>
          </div>
        </details>
      </div>

      <div className="mx-auto mt-10 max-w-[820px] px-4">
        <ToolBasis />
      </div>

      <GuideNavigator />
      <IntentLinks />
      <DoutoConduta />
      <EditorialContent />
      <FAQ />
      <ReferencesAndAuthor />
    </div>
  );
}
